import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { categories } from "@/mocks/site";

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const handleSearch = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const query = keyword.trim();
    navigate(query ? `/events?q=${encodeURIComponent(query)}` : "/events");
  };

  return (
    <section className="relative flex min-h-[600px] w-full items-center justify-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20collage%20of%20glowing%20social%20notification%20bubbles%20and%20floating%20paper%20cards%20over%20deep%20terracotta%20and%20charcoal%20background%2C%20cinematic%20dramatic%20rim%20lighting%2C%20grainy%20textured%20paper%2C%20high%20contrast%2C%20moody%20atmosphere%2C%20no%20readable%20text&width=1800&height=1000&seq=cf-hero-2026&orientation=landscape"
          alt="网红事件深度复盘主题插画背景"
          title="吃瓜复盘局 - 网红事件完整经过与深度解析"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/88"></div>
      </div>

      <div className="relative z-10 w-full px-4 pb-16 pt-28 md:px-8 md:pb-24 md:pt-36">
        <div className="mx-auto w-full max-w-4xl text-center">
          <p className="mx-auto inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-100 backdrop-blur">
            <i className="ri-flashlight-fill text-accent-300"></i>
            网红事件 · 完整经过 · 每日更新
          </p>

          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-[56px]">
            网红事件完整经过，
            <br className="hidden sm:block" />
            前因后果一次说清
          </h1>

          <p className="mx-auto mt-5 max-w-2xl text-sm leading-7 text-background-100/85 md:text-base">
            从起因到发酵全程复盘，深挖各方关键信息与争议焦点。不做情绪输出，只按时间线把来龙去脉讲明白，让你看完一篇就能自己下判断。
          </p>

          <form
            onSubmit={handleSearch}
            className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-2 sm:flex-row"
          >
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索事件、人物或关键词"
                aria-label="搜索网红事件"
                className="h-12 w-full rounded-md border border-background-50/20 bg-background-50/95 pl-11 pr-4 text-sm text-foreground-950 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-300/60"
              />
            </div>
            <button
              type="submit"
              className="h-12 whitespace-nowrap rounded-md bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索复盘
            </button>
          </form>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-2">
            {categories.map((category) => (
              <li key={category.slug}>
                <button
                  type="button"
                  onClick={() => navigate(`/events?category=${category.slug}`)}
                  className="cursor-pointer rounded-full border border-background-50/25 bg-background-50/10 px-3.5 py-1.5 text-xs text-background-100 backdrop-blur transition-colors hover:border-accent-300 hover:text-accent-200"
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}